import { MapLatLng } from '../models/map.latlng';
import { MapPolygon } from '../models/map.polygon';
import { MapPolygonPoint } from '../models/map.polygonPoint';
import { GMapComponent } from './gmap.component';

declare var google: any;

export class GPolygon extends MapPolygon {
    private pointContents: string[] = [];
    private dataModel: any[] = [];
    private gMap: GMapComponent;
    private timerEdit?: any;
    private canEdit = false;
    private markerText: any;

    constructor(id: number, map: any, strokeColor: string, strokeOpacity: number,
        weight: number, fillColor: string, fillOpacity: number, editable: boolean, hole: boolean,
        gMap: GMapComponent, content: string) {
        super(id, map, strokeColor, strokeOpacity, weight, fillColor, fillOpacity, editable, hole, content);
        this.gMap = gMap;
        this.polygon = new google.maps.Polygon({
            strokeColor: strokeColor,
            strokeOpacity: strokeOpacity,
            strokeWeight: weight,
            fillColor: fillColor,
            fillOpacity: fillOpacity,
            clickable: true,
            geodesic: true,
            editable: editable
        });
        // Si es editable los puntos se añaden por evento
        if (editable) {
            google.maps.event.addListener(this.polygon.getPath(), 'insert_at', (index: number) => {
                const point = this.polygon.getPath().getArray()[index];
                const newPoint = new MapPolygonPoint(index + 1, this.pointContents[point.lat() + point.lng()],
                    new MapLatLng(point.lat(), point.lng()), this.dataModel[point.lat() + point.lng()])
                this.points.splice(index, 0, newPoint);
                if (this.timerEdit) {
                    clearTimeout(this.timerEdit);
                }
                // Esto es porque pasa por aqui también cuando se crean los puntos de un polígono
                // cuando se carga un polígono por primera vez por ejemplo
                this.timerEdit = setTimeout(() => {
                    this.canEdit = true;
                    clearTimeout(this.timerEdit);
                    this.timerEdit = null;
                }, 250);
                if (this.canEdit) {
                    // Evento para que se sepa que ha cambiado el polígono
                    this.gMap.onPolygonDragEnd(this.points[index - 1]);
                }
            });
            google.maps.event.addListener(this.polygon.getPath(), 'remove_at', (index: number) => {
                this.points.splice(index, 1);
            });
            google.maps.event.addListener(this.polygon.getPath(), 'set_at', (index: number, oldPos: any) => {
                const point = this.polygon.getPath().getArray()[index];
                this.points[index] = new MapPolygonPoint(index + 1, this.pointContents[oldPos.lat() + oldPos.lng()],
                    new MapLatLng(point.lat(), point.lng()), this.dataModel[oldPos.lat() + oldPos.lng()]);
                this.pointContents[point.lat() + point.lng()] = this.pointContents[oldPos.lat() + oldPos.lng()];
                this.dataModel[point.lat() + point.lng()] = this.dataModel[oldPos.lat() + oldPos.lng()];
                // Evento para que se sepa que ha cambiado el polígono
                this.gMap.onPolygonDragEnd(this.points[index]);
            });
        }
        this.polygon.setMap(this.map);
    }

    addPoint(id: number, content: string, position: MapLatLng, dataModel: any): MapPolygonPoint {
        this.pointContents[position.lat + position.lng] = content;
        this.dataModel[position.lat + position.lng] = dataModel;
        const point = new MapPolygonPoint(id, content, position, dataModel);
        this.polygon.getPath().push(new google.maps.LatLng(position.lat, position.lng));
        // Si no es editable añado ya el punto a la lista
        if (!this.editable) {
            this.points.push(point);
        }
        this.setContentInterno(content, position);
        return point;
    }

    getCentroid(): MapLatLng {
        const centroide = new MapLatLng(0, 0);
        for (let i = 0; i < this.points.length; i++) {
            centroide.lat += this.points[i].point.lat;
            centroide.lng += this.points[i].point.lng;
        }
        centroide.lat /= this.points.length;
        centroide.lng /= this.points.length;
        return centroide;
    }

    remove() {
        this.polygon.setMap(null);
        if (this.markerText) {
            this.markerText.setMap(null);
        }
    }

    // Devuelve el punto del polígono más cercano a un punto dado
    getNearbyPoint(position: any): any {
        let res: MapPolygonPoint | undefined;
        let i = 0, index = 0;
        let oldDist = 99999999;
        let lastPoint: MapPolygonPoint | undefined;
        for (i = 0; i < this.points.length; i++) {
            if (lastPoint) {
                const dist = this.gMap.distancePointToSegment(lastPoint.point.lng, lastPoint.point.lat, this.points[i].point.lng,
                    this.points[i].point.lat, position.lng(), position.lat());
                if (dist < oldDist) {
                    index = i;
                    oldDist = dist;
                }
            }
            lastPoint = this.points[i];
        }
        if (index > 0) {
            if (google.maps.geometry.spherical.computeDistanceBetween(position,
                new google.maps.LatLng(this.points[index].point.lat, this.points[index].point.lng)) <
                google.maps.geometry.spherical.computeDistanceBetween(position,
                    new google.maps.LatLng(this.points[index - 1].point.lat, this.points[index - 1].point.lng))) {
                res = this.points[index];
            } else {
                res = this.points[index - 1];
            }
        }
        return res;
    }

    setContentInterno(content: string, position: MapLatLng) {
        // La primera vez creo el texto si hay...
        if (this.content && this.content.length > 0) {
            if (!this.markerText) {
                this.markerText = new google.maps.Marker({
                    position: new google.maps.LatLng(position.lat, position.lng),
                    label: this.content,
                    map: this.map,
                    icon: 'assets/images/void.png'
                });
            } else {
                this.markerText.setPosition(this.getCentroid());
            }
        }
    }

    setContent(content: string) {
        this.content = content;
        for (let i = 0; i < this.points.length; i++) {
            this.points[i].content = content;
        }
        if (this.markerText) {
            this.markerText.setMap(null);
            this.markerText = null;
        }
        this.setContentInterno(content, this.getCentroid());
    }

}
